export const PROGRESS_STEP_LOCALE_ZHCHT = {
    empty: 'æ­¥é©æ¢ä¿¡æ¯çºç©º'
};
